/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable camelcase */
import {
  faDownload,
  faEdit,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import CsvDownloader from "react-csv-downloader";
import { CSVReader } from "react-papaparse";
import {
  sess_delete,
  sess_get,
  sess_post,
  sess_put,
} from "../../../utils/HttpRequests";
import { OperationModal } from "../common";
import EditProrityInTrustedService from "./EditPriorityTrustedService";
import "./TrustedServices.css";

const TrustedServices = () => {
  const [trustedServices, setTrustedServices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddServiceModal, setShowAddServiceModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [error, setError] = useState("");
  const [service, setService] = useState({
    name: "",
    organization: "",
    priority: 0,
    status: "no",
    icon: "",
    numbers: "",
    _id: "",
  });

  const showModalAndAssignService = (serv) => {
    setShowModal(true);
    console.log("serv", serv);
    setModalContent(serv);
  };

  const getAllTrustedServices = async () => {
    try {
      const sessionToken = localStorage.getItem("admin-panel-sessionToken");
      const trustedServicesResponse = await sess_get(
        "admin/console/trusted-services",
        sessionToken
      );
      await setTrustedServices(trustedServicesResponse.data.response.services);
      setError("");
    } catch (err) {
      setError(err.message || "Some thing went wrong");
    }
  };

  useEffect(() => {
    setError("");
    async function getData() {
      await getAllTrustedServices();
      setService({ ...service, priority: trustedServices.length });
    }
    getData();

    return () => {};
  }, []);
  const columns = [{ id: "contact_nos", displayName: "Masked Numbers" }];
  const trustedServicesTableContent = trustedServices.map((trustedService) => (
    <>
      <tr>
        <td>
          <center>
            <img
              src={trustedService.icon_url}
              alt={trustedService.name}
              style={{ width: "25px", height: "25px" }}
            />
          </center>
        </td>
        <td>{trustedService.name}</td>
        <td>{trustedService.organization}</td>
        <td>
          <span style={{ paddingRight: "2%" }}>
            <CsvDownloader
              filename={`${
                trustedService.name
              }_${new Date().toLocaleDateString()}`}
              separator=","
              columns={columns}
              datas={
                trustedService.contact_nos.length
                  ? trustedService.contact_nos.map((detail) => ({
                      contact_nos: detail,
                    }))
                  : [{}]
              }
              // className="SearchButton BgGreen"
              text={trustedService.count}
            >
              <div>
                {trustedService.count}

                <FontAwesomeIcon
                  icon={faDownload}
                  style={{ width: "10%" }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                />
              </div>
            </CsvDownloader>
            {/* <img src={download} /> */}
          </span>
        </td>
        <td>{trustedService.priority}</td>
        <td>
          <FontAwesomeIcon
            style={{ margin: "0 10px" }}
            icon={faTrashAlt}
            onClick={(e) => {
              e.preventDefault();
              setShowModal(true);
              showModalAndAssignService(trustedService);
            }}
          />
          <FontAwesomeIcon
            icon={faEdit}
            onClick={(e) => {
              e.preventDefault();
              setShowEditModal(true);
              setService({
                name: trustedService.name,
                organization: trustedService.organization,
                priority: trustedService.priority,
                status: trustedService.active ? "yes" : "no",
                _id: trustedService._id,
              });
            }}
          />
        </td>
      </tr>
    </>
  ));

  const deleteTrustedService = async (serviceToDelete) => {
    try {
      const sessionToken = localStorage.getItem("admin-panel-sessionToken");
      const params = {
        _id: serviceToDelete._id,
        id: serviceToDelete.id,
      };
      await sess_delete("admin/console/trusted-service", sessionToken, params);
      getAllTrustedServices();
      setShowModal(false);
      setError("");
    } catch (err) {
      setModalContent(false);
      setError(err.message);
    }
  };

  const resetService = () => {
    setService({
      name: "",
      organization: "",
      priority: 0,
      status: "no",
      icon: "",
      numbers: "",
    });
  };

  const onModalInputChange = (e) => {
    // console.log(id, value);
    setService({ ...service, [e.target.id]: e.target.value });
  };

  const onModalFileUpload = (e) => {
    e.preventDefault();
    setService({ ...service, [e.target.id]: e.target.files[0] });
  };

  const serviceValidate = () => {
    const { name, organization, status, icon, numbers } = service;
    let isServiceValid = true;
    if (!name) {
      setError("name is required");
      isServiceValid = false;
      return isServiceValid;
    }
    if (!organization) {
      setError("Organization name is required");
      isServiceValid = false;
      return isServiceValid;
    }
    if (!status) {
      setError("status is required");
      isServiceValid = false;
      return isServiceValid;
    }
    if (!icon) {
      setError("Logo file cannot be empty");
      isServiceValid = false;
      return isServiceValid;
    }
    if (!numbers) {
      setError("upload numbers file cannot be empty");
      isServiceValid = false;
      return isServiceValid;
    }
    return true;
  };

  const addService = async () => {
    try {
      if (serviceValidate()) {
        setError("");
        const formData = new FormData();
        const { name, organization, status, icon, numbers } = service;
        formData.append("name", name);
        formData.append("organization", organization);
        formData.append("status", status);
        formData.append("icon", icon);
        formData.append("numbers", numbers);
        formData.append("priority", trustedServices.length + 1);
        const sessionToken = localStorage.getItem("admin-panel-sessionToken");
        await sess_post(
          "admin/console/trusted-service",
          sessionToken,
          formData
        );
        setShowAddServiceModal(false);
        getAllTrustedServices();
        resetService();
      } else {
        setError("service not valid, one or more required params missing");
      }
    } catch (err) {
      setError(err.message || "something went wrong add service");
    }
  };

  const editService = async () => {
    try {
      // if (serviceValidate()) {
      setError("");
      const formData = new FormData();
      const { name, organization, status, icon, numbers, priority, _id } =
        service;
      if (name) formData.append("name", name);
      if (organization) formData.append("organization", organization);
      if (status) formData.append("status", status);
      if (icon) formData.append("icon", icon);
      formData.append("_id", _id);
      if (numbers) formData.append("numbers", numbers);
      if (priority) formData.append("priority", priority);
      const sessionToken = localStorage.getItem("admin-panel-sessionToken");
      console.log(service);
      await sess_put("admin/console/trusted-service", sessionToken, formData);
      setShowEditModal(false);
      resetService();
      getAllTrustedServices();
      // } else {
      //   setError("service not valid, one or more required params missing");
      // }
    } catch (err) {
      setError(
        err?.response?.data?.error?.reason || "something went wrong add service"
      );
    }
  };

  const handleOnDrop = (data) => {
    data = data.map((item) => {
      return item.data[0];
    });
    setService({ ...service, numbers: data });
  };

  const handleOnRemoveFile = () => {
    setService({ ...service, numbers: [] });
    // this.setState({
    // numbersToBeUploaded: [],
    // msg: "",
    // csvUploadSuccess: false,
    // });
  };

  return (
    <div className="container">
      <div className="trusted-service-content">Trusted Services</div>
      <div className="trusted-service-content">
        <Button
          variant="danger"
          onClick={() => {
            setShowAddServiceModal(true);
          }}
        >
          Add Service
        </Button>
        <OperationModal
          closeButton={false}
          // onHide={() => setShowAddServiceModal(false)}
          modalContent={
            <div>
              <form className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-12" htmlFor="name">
                    Service Name
                    <input
                      className="form-control service-input"
                      id="name"
                      placeholder="Enter name"
                      name="name"
                      type="text"
                      value={service.name}
                      onChange={onModalInputChange}
                    />
                  </label>
                  <label className="col-sm-12" htmlFor="organization">
                    Organization
                    <input
                      className="form-control service-input"
                      id="organization"
                      placeholder="Enter organization"
                      name="Organization"
                      type="text"
                      value={service.organization}
                      onChange={onModalInputChange}
                    />
                  </label>
                  <label className="col-sm-12" htmlFor="status">
                    Toggle Status
                    <select
                      className="form-control"
                      id="status"
                      onChange={onModalInputChange}
                      value={service.status}
                      style={{ height: "50px" }}
                    >
                      <option value="" selected="selected">
                        Select
                      </option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </label>
                  <label className="col-sm-12" htmlFor="priority">
                    Priority
                    <input
                      className="form-control service-input"
                      id="priority"
                      placeholder="Enter organization"
                      name="Priority"
                      type="number"
                      disabled
                      value={trustedServices.length + 1}
                    />
                  </label>
                  <label className="col-sm-6" htmlFor="icon">
                    Upload Icon
                    <input
                      type="file"
                      style={{ border: "none" }}
                      id="icon"
                      name="logo"
                      accept=".jpg,'jpeg,.png"
                      onChange={onModalFileUpload}
                    />
                  </label>
                  <label className="col-sm-6" htmlFor="numbers">
                    Upload Numbers
                    <p style={{ margin: "0", color: "red", fontSize: "14px" }}>
                      NOTE: No Headers required in file
                    </p>
                    {/* <input
                      type="file"
                      style={{ border: "none" }}
                      id="numbers"
                      name="csv"
                      accept=".csv"
                      onChange={onModalFileUpload}
                    /> */}
                    <CSVReader
                      onDrop={handleOnDrop}
                      // onError={this.handleOnError}
                      addRemoveButton
                      removeButtonColor="#659cef"
                      onRemoveFile={handleOnRemoveFile}
                    >
                      <span>Drop CSV file here or click to upload.</span>
                    </CSVReader>
                  </label>
                  {error && (
                    <div style={{ marginLeft: "1em", color: "red" }}>
                      {error}
                    </div>
                  )}
                </div>
              </form>
            </div>
          }
          show={showAddServiceModal}
          title="Add Service"
          success={addService}
          failure={() => {
            setShowAddServiceModal(false);
          }}
        />
      </div>

      <div className="trusted-service-table">
        <table>
          <thead>
            <tr>
              <th />
              <th scope="col">
                <center>
                  <a style={{ color: "#337ab7" }}>SenderId</a>
                </center>
              </th>
              <th scope="col">
                <center>
                  <a style={{ color: "#337ab7" }}>Organization</a>
                </center>
              </th>
              <th scope="col">
                <center>
                  <a style={{ color: "#337ab7" }}>Masked Numbers Count</a>
                </center>
              </th>
              <th scope="col">
                <a style={{ color: "#337ab7" }}>
                  <span style={{ paddingRight: "5%" }}>Priority</span>
                  <EditProrityInTrustedService
                    getAllTrustedServices={getAllTrustedServices}
                    trustedServices={trustedServices}
                  />
                </a>
              </th>
              <th scope="col">
                <center>
                  <a style={{ color: "#337ab7" }}>Action</a>
                </center>
              </th>
            </tr>
          </thead>
          <tbody>{trustedServicesTableContent}</tbody>
        </table>
        {error && (
          <div style={{ color: "red", textAlign: "center" }}>{error}</div>
        )}
      </div>

      <OperationModal
        onHide={() => setShowModal(false)}
        show={showModal}
        title="Trusted Service"
        success={() => deleteTrustedService(modalContent)}
        failure={() => {
          setShowModal(false);
        }}
        setShowModal={setShowModal}
        modalContent={`Are you sure want to delete sender ${modalContent.name}`}
      />
      <OperationModal
        onHide={() => {
          setShowEditModal(false);
          resetService();
        }}
        show={showEditModal}
        success={editService}
        failure={() => {
          setShowEditModal(false);
          resetService();
          setError("");
        }}
        title="Edit Service"
        modalContent={
          <div>
            <form className="form-horizontal">
              <div className="form-group">
                <label className="col-sm-12" htmlFor="name">
                  Service Name
                  <input
                    className="form-control service-input"
                    id="name"
                    placeholder="Enter name"
                    name="name"
                    type="text"
                    value={service.name}
                    defaultValue={modalContent.name}
                    onChange={onModalInputChange}
                  />
                </label>
                <label className="col-sm-12" htmlFor="organization">
                  Organization
                  <input
                    className="form-control service-input"
                    id="organization"
                    placeholder="Enter organization"
                    name="Organization"
                    type="text"
                    value={service.organization}
                    onChange={onModalInputChange}
                  />
                </label>
                <label className="col-sm-12" htmlFor="status">
                  Toggle Status
                  <select
                    className="form-control"
                    id="status"
                    onChange={onModalInputChange}
                    value={service.status}
                    style={{ height: "50px" }}
                  >
                    <option value="" selected="selected">
                      Select
                    </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </label>
                <label className="col-sm-12" htmlFor="priority">
                  Priority
                  <input
                    className="form-control service-input"
                    id="priority"
                    placeholder="Enter organization"
                    name="Priority"
                    type="number"
                    onChange={onModalInputChange}
                    value={service.priority}
                  />
                </label>
                <label className="col-sm-6" htmlFor="icon">
                  Upload Icon
                  <input
                    type="file"
                    style={{ border: "none" }}
                    id="icon"
                    name="logo"
                    accept=".jpg,'jpeg,.png"
                    onChange={onModalFileUpload}
                  />
                </label>
                <label className="col-sm-6" htmlFor="numbers">
                  Upload Numbers
                  <p style={{ margin: "0", color: "red", fontSize: "14px" }}>
                    NOTE: No Headers required in file
                  </p>
                  <CSVReader
                    onDrop={handleOnDrop}
                    // onError={this.handleOnError}
                    addRemoveButton
                    removeButtonColor="#659cef"
                    onRemoveFile={handleOnRemoveFile}
                  >
                    <span>Drop CSV file here or click to upload.</span>
                  </CSVReader>
                </label>
                {error && (
                  <div style={{ marginLeft: "1em", color: "red" }}>{error}</div>
                )}
              </div>
            </form>
          </div>
        }
      />
    </div>
  );
};

export default TrustedServices;
